import React from "react";

export function PriceTag({ amount, period }) {
  const [whole, decimal] = amount.toFixed(2).split(".");
  return (
    <div className="flex items-baseline gap-1 font-mono">
      <span className="text-zinc-500 text-sm">$</span>
      <span className="text-3xl text-white font-semibold leading-none">{whole}</span>
      <span className="text-zinc-500 text-sm">.{decimal}</span>
      {period && <span className="text-zinc-600 text-xs ml-1 uppercase tracking-widest">/ {period}</span>}
    </div>
  );
}
